/**
 * Detect if device is iOS
 * @returns {boolean}
 */
export const isIOS = () => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};

/**
 * Open the native SMS composer
 * @param {string} shortCode - Short code to send SMS to
 * @param {string} keyword - Keyword to send
 */
export const prepareAndInitSMS = (shortCode, keyword) => {
  const smsCommand = isIOS()
    ? `sms://open?addresses=${shortCode};?&body=${keyword}`
    : `sms:${shortCode};?&body=${keyword}`;
  window.location.assign(smsCommand);
};
